module.exports = __webpack_public_path__ + "static/media/Conexie-1.25bdc7dc.webp";